import React from "react";
import RegistrationWizardState from "../registrationWizardState";

const WizardStepper = ({ stepIndex }) => {
  const totalSteps = RegistrationWizardState.getTotalSteps();

  return (
    <div className="clinician-onboard-stepper">
      {Array.from({ length: totalSteps }, (_, i) => {
        const state = i === stepIndex ? "active" : i < stepIndex ? "completed" : "";

        return (
          <div key={i} className="clinician-onboard-stepper__item">
            <div className={`clinician-onboard-stepper__circle ${state}`}>
              {i < stepIndex ? "✓" : i + 1}
            </div>
            <div className={`clinician-onboard-stepper__dot ${state}`} aria-hidden="true" />
          </div>
        );
      })}
    </div>
  );
};

export default WizardStepper;
